<template>
    <div class="alkene">
        <ul>
            <li>C<sub>n</sub>H<sub>2n</sub></li>
            <li>sp<sup>2</sup> hybridisiert</li>
            <li>unpolar</li>
            <li>niedrige Siedetemp.</li>
            <li>brennbar</li>
            <li>-en</li>
            <li>
                Nachweis (elektrophile Addition):<br />Entfärbt Br<sub>2</sub>
                Polymerisation
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'alkene',
};
</script>
